import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

const MIN_IFRAME_WIDTH_PX = 400;
const MAX_IFRAME_WIDTH_PX = 880;
const DEFAULT_IFRAME_WIDTH_PX = 400;

interface ResizeButtonsConfig {
  minWidth: number;
  maxWidth: number;
  defaultWidth: number;
}

@Injectable({
  providedIn: 'root',
})
export class IframeResizeService {
  private currentWidth: number = DEFAULT_IFRAME_WIDTH_PX;

  constructor(private logger: LoggerService) {}

  getCurrentWidth(): number {
    return this.currentWidth;
  }

  setWidth(width: number): boolean {
    const parsedWidth = Math.round(width);
    this.logger.info(
      `IFRAME_RESIZE - Tentando aplicar largura: ${parsedWidth}px`,
    );
    if (!this.isValidWidth(parsedWidth)) {
      this.logger.warn(
        `IFRAME_RESIZE - Largura invalida: ${width}. Intervalo permitido: ${MIN_IFRAME_WIDTH_PX}-${MAX_IFRAME_WIDTH_PX}`,
      );
      return false;
    }

    try {
      const runtimeWindow = window as Window & {
        Microsoft?: {
          CIFramework?: {
            setWidth?: (value: number) => void;
          };
        };
      };
      const ciFramework = runtimeWindow.Microsoft?.CIFramework;

      if (typeof ciFramework?.setWidth === 'function') {
        ciFramework.setWidth(parsedWidth);
        this.currentWidth = parsedWidth;
        return true;
      }

      this.logger.warn(
        'IFRAME_RESIZE - Microsoft.CIFramework.setWidth nao esta disponivel.',
      );
      return false;
    } catch (error) {
      this.logger.error(
        'IFRAME_RESIZE - Falha ao aplicar largura do iframe.',
        error,
      );
      return false;
    }
  }

  resetToDefault(): boolean {
    return this.setWidth(DEFAULT_IFRAME_WIDTH_PX);
  }

  getConfig(): ResizeButtonsConfig {
    return {
      minWidth: MIN_IFRAME_WIDTH_PX,
      maxWidth: MAX_IFRAME_WIDTH_PX,
      defaultWidth: DEFAULT_IFRAME_WIDTH_PX,
    };
  }

  private isValidWidth(width: number): boolean {
    return (
      Number.isFinite(width) &&
      width >= MIN_IFRAME_WIDTH_PX &&
      width <= MAX_IFRAME_WIDTH_PX
    );
  }
}
